import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'providerFilter'
})
export class ProviderFilterPipe implements PipeTransform {

  transform(items: any[], searchText : string): any[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLocaleLowerCase();

    return items.filter(item => {
      if (item.data.name.toLocaleLowerCase().includes(searchText))
        return true;
      if (item.data.phone.includes(searchText))
        return true;
      if (item.data.email.toLocaleLowerCase().includes(searchText))
        return true;
      return false;
    });
  }

}
